import { useLayoutEffect } from "react"

import { Space, Typography } from "antd"
import { t } from "i18next"
import { useDispatch, useSelector } from "react-redux"

import Private from "../../../../Components/Private"
import ReferralActions from "../../../Referrals/reducer"

import "./ShareLink.less"

const { Text } = Typography

const ShareLink = () => {
  const dispatch = useDispatch()
  const link = useSelector((state) => state.referrals?.inviteLink)
  const { userInfo } = useSelector((state) => state.auth)
  const visibleLink = userInfo?.is_demo ? "https://app.chargeback.io/example" : link

  useLayoutEffect(() => {
    dispatch(ReferralActions.getInviteLinkRequest())
  }, [])

  return (
    <Space direction="vertical" size={8} className="share-link">
      <Text>{t("Share this unique link to invite your friends")}</Text>
      <div className="share-link__box">
        <span className="share-link__text" title={visibleLink}>
          <Private>{visibleLink}</Private>
        </span>
        <Text className="share-link__copy" copyable={{ tooltips: false, text: visibleLink }} />
      </div>
    </Space>
  )
}

export default ShareLink
